// url.jsx
  //  const BaseUrl = "https://aakarcanvanssing-backend.vercel.app";
  //  const BaseUrl = "http://localhost:5000";
  const BaseUrl = "https://admin.aakarcanvassing.com";

export { BaseUrl };

